import { productCategoryIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const ProductCategorySchema_ = z.object({
  id: productCategoryIdFormat.schema,
  name: z.string(),
  hasChildren: z.boolean(),
});

export const ProductCategorySchema: z.ZodType<ProductCategory> =
  ProductCategorySchema_;
export interface ProductCategory
  extends z.infer<typeof ProductCategorySchema_> {}

const ParentCategorySchema_ = z.object({
  id: productCategoryIdFormat.schema,
  name: z.string(),
});

export const ParentCategorySchema: z.ZodType<ParentCategory> =
  ParentCategorySchema_;
export interface ParentCategory extends z.infer<typeof ParentCategorySchema_> {}

export const getProductCategories = {
  name: "getProductCategories" as const,
  input: z.object({
    categoryId: productCategoryIdFormat.schema.nullable(),
  }),
  output: z.object({
    categories: z.array(ProductCategorySchema),
    parent: ParentCategorySchema.nullable(),
  }),
};
